import React, { useRef, useContext } from 'react';
import { FaSync, FaPrint, FaPlus } from 'react-icons/fa';
import { Button,Box } from '@chakra-ui/react';
import "../../Teacher/teacher.css";
import List from './List';

import { useNavigate } from 'react-router-dom';
import FeesMasterModal from './Fees_Master';

const Fees_Group = () => {
    const navigate = useNavigate();
  

    const handleClick = () => {
        navigate('/teachers/add'); // Navigate to the desired route
    };


    return (
        <div style={{ backgroundColor: '#FBFBFD', height: '100vh' }}>
            <div className="teacher-list-container">
                <div className="header">
                    <h1 fontSize="20px">Fees Master</h1>
                    <div className="action-buttons">
                        {/* <Button
                            className="refresh-button"
                            boxShadow="md" // Applies a medium shadow
                            backgroundColor='white'
                            fontSize='11px'
                            onClick={() => {
                                // Add refresh functionality here
                                console.log('Refresh button clicked');
                            }}
                            display={{ base: 'none', md: 'flex' }}

                        >
                            <FaSync color='#515B73' />
                        </Button> */}

                        <div className="export-dropdown">
                            <Button className="export-button" display={{ base: 'none', md: 'flex' }}
                                backgroundColor='white' fontSize='11px' boxShadow="md" >
                                <FaPrint color='#515B73' />
                                Print PDF
                            </Button>
                        </div>

                        <FeesMasterModal />
                     
                    </div>
                </div>

                <div className="breadcrumb">
                    <span>Admin</span> / <span>Fees</span> / <span>Fees Master </span>
                </div>
            </div>

            <div id="teacher-list-content">
                <List />
            </div>



        
        </div>
    );
};

export default Fees_Group;
